/**
 * Agent Service API endpoints.
 * Kept separate from query-service endpoints for SRP.
 */
export const AGENT_API_BASE_URL = process.env.REACT_APP_AGENT_API_BASE_URL
    || 'http://localhost:8086/apmt-cdh-agent-service';

export const METADATA_AGENT_ID = process.env.REACT_APP_METADATA_AGENT_ID
    || 'b1a20000-0000-0000-0000-000000000006';

export const AGENT_ENDPOINTS = {
    agents: '/agents',
    agentById: (id: string) => `/agents/${id}`,
    deploy: (id: string) => `/agents/${id}/deploy`,
    pause: (id: string) => `/agents/${id}/pause`,
    test: (id: string) => `/agents/${id}/test`,
    execute: (id: string) => `/agents/${id}/execute`,
    logs: (id: string) => `/agents/${id}/logs`,
    promptTemplates: '/prompt-templates',
    queryBuilderGenerate: '/agents/query-builder/generate',
};
